import { render, staticRenderFns } from "./ModalForm.vue?vue&type=template&id=613ef69a&scoped=true&"
import script from "./ModalForm.vue?vue&type=script&lang=js&"
export * from "./ModalForm.vue?vue&type=script&lang=js&"
import style0 from "./ModalForm.vue?vue&type=style&index=0&id=613ef69a&scoped=true&lang=css&"
import style1 from "./ModalForm.vue?vue&type=style&index=1&id=613ef69a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613ef69a",
  null
  
)

export default component.exports